import { Controller, useFormContext } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";

import { AbsCheckBox, Label } from "abs-ui-components";
import { Input } from "abs-ui-components";
import { preventScientificNotation } from "../../../../../../services/utilities";

const CargoForm = ({ section, type, onSailingInIceChange }) => {
	const {
		control,
		formState: { errors },
	} = useFormContext();

	const sanitizeKey = (key) => {
		if (!key) return "";
		return key.replace(/\|/g, "").replace(/\./g, "_");
	};


	const convertToBoolean = (value) => {
		return value === "True"; // Converts "True" to true, and anything else (including "False") to false
	};

	const handleSailing = (e, field) => {
		const isChecked = e.target.checked;
		field.onChange(isChecked);

		if (onSailingInIceChange) {
			onSailingInIceChange(isChecked);
		}
	};
	return (
		<>
			<>
				{(section.sectionName === "Cargo Details" ||
					section.sectionName === "CargoMepc Details") && (
						<MDBRow className="mt-4">
							{section?.fields?.map((formField, fieldIndex) => (
								<>
									<MDBCol
										md="3"
										className="pr-2 mt-3"
										key={`${formField.key}-${fieldIndex}`}
									>
										{formField.dataType === "decimal" && (
											<>
												<Label
													bold
													name={formField.fieldName}
													className="mb-1"
												/>
												<Controller
													name={
														sanitizeKey(formField.key)
													}
													control={control}
													defaultValue={
														type === "Edit"
															? formField.value ||
															null
															: ""
													}
													render={({ field }) => {
														// Ensure field is defined before accessing properties
														if (!field) return null; // Return null if field is undefined

														return (
															<Input
																{...field} // Spread the field props from Controller
																className="inputHeight"
																type="number"
																step="any"
																onChange={(e) => {
																	field.onChange(
																		e
																	);
																}}
																autoFocus={false}
																value={
																	field?.value ??
																	""
																} // Safely use field.value or fallback to ''
																onKeyDown={(e) => {
																	preventScientificNotation(
																		e
																	);
																	// Prevent up and down arrow keys
																	if (
																		e.key ===
																		"ArrowUp" ||
																		e.key ===
																		"ArrowDown"
																	) {
																		e.preventDefault();
																	}
																}}
																onWheel={(e) =>
																	e.target.blur()
																}
															/>
														);
													}}
												/>
											</>
										)}

										{formField.dataType === "boolean" && (
											<>
												<Label
													bold
													name={formField.fieldName}
													className="mb-1"
												/>
												<Controller
													name={formField.key}
													defaultValue={
														type === "Edit"
															? convertToBoolean(
																formField.value
															) // Convert to boolean
															: null
													}
													render={({ field }) => {
														return (
															<div className="mt-2">
																<AbsCheckBox
																	handleChange={(
																		e
																	) =>
																		handleSailing(
																			e,
																			field
																		)
																	}
																	id="sailingInIce"
																	onChange={(
																		e
																	) => {
																		field.onChange(
																			e
																		);
																	}}
																	{...field}
																	checked={
																		field.value
																	}
																	value={
																		field.value
																	}
																/>
															</div>
														);
													}}
												/>
											</>
										)}
									</MDBCol>
								</>
							))}
						</MDBRow>
					)}
			</>
		</>
	);
};

export default CargoForm;
